import { globalTheme } from '../../../../../shared/theme/theme';
import { TextToColorMapModel } from '../../../../shared/models/text-to-color-map.model';
import { VehicleCampaignStatusEnum } from '../../../enums/vehicle-campaign-status.enum';

export const vehicleCampaignStatusMap: Map<
  VehicleCampaignStatusEnum,
  TextToColorMapModel
> = new Map([
  [
    VehicleCampaignStatusEnum.EXECUTED,
    {
      textContent: 'Executed',
      textColor: globalTheme.palette.primary.main,
    },
  ],
  [
    VehicleCampaignStatusEnum.CANCELED,
    {
      textContent: 'Canceled',
      textColor: globalTheme.palette.black.main,
    },
  ],
  [
    VehicleCampaignStatusEnum.ERROR,
    {
      textContent: 'Error',
      textColor: globalTheme.palette.error.main,
    },
  ],
  [
    VehicleCampaignStatusEnum.UNKNOWN,
    {
      textContent: 'Unknown',
      textColor: globalTheme.palette.black.main,
    },
  ],
]);
